import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  Animated,
  Dimensions,
  Easing,
} from "react-native";

interface ConnectionPopupProps {
  onClose: () => void;
  pauseMessage?: string;
}

const ConnectionPopup: React.FC<ConnectionPopupProps> = ({
  onClose,
  pauseMessage = "The stream is currently paused",
}) => {
  const spinValue = new Animated.Value(0);
  const gradientValue = new Animated.Value(0);

  useEffect(() => {
    const spinAnimation = Animated.loop(
      Animated.timing(spinValue, {
        toValue: 1,
        duration: 1000,
        easing: Easing.linear,
        useNativeDriver: true,
      })
    );
    const gradientAnimation = Animated.loop(
      Animated.timing(gradientValue, {
        toValue: 1,
        duration: 2000,
        easing: Easing.linear,
        useNativeDriver: false,
      })
    );

    spinAnimation.start();
    gradientAnimation.start();

    return () => {
      spinAnimation.stop();
      gradientAnimation.stop();
    };
  }, [spinValue, gradientValue]);

  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });

  const gradientRotation = gradientValue.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });

  const { width } = Dimensions.get("window");

  return (
    <View style={styles.overlay}>
      <View style={[styles.popup, { width: width * 0.8, maxWidth: 400 }]}>
        <Animated.View
          style={[
            styles.loadingCircle,
            { transform: [{ rotate: spin }] },
            styles.ouroborosBackground,
            {
              borderColor: gradientValue.interpolate({
                inputRange: [0, 0.5, 1],
                outputRange: ["#9370DB", "#6A0DAD", "#9370DB"],
              }),
              transform: [{ rotate: gradientRotation }],
            },
          ]}
        />
        <Text style={styles.message}>{pauseMessage}</Text>
        <Text style={styles.subMessage}>
          Looks like there's a connection issue.
        </Text>
        <Text style={styles.subMessage}>
          Hang tight — we're trying to reconnect...
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  popup: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
  },
  loadingCircle: {
    width: 50,
    height: 50,
    borderRadius: 25,
    borderWidth: 5,
    borderTopColor: "#fff",
  },
  ouroborosBackground: {
    backgroundColor: "rgba(147, 112, 219, 0.2)",
    borderStyle: "solid",
    overflow: "hidden",
  },
  message: {
    color: "#fff",
    fontSize: 18,
    fontWeight: "bold",
    marginTop: 10,
    textAlign: "center",
  },
  subMessage: {
    color: "#fff",
    fontSize: 14,
    textAlign: "center",
    marginTop: 5,
    lineHeight: 20,
  },
});

export default ConnectionPopup;
